import { Divider, Flex, Spacing } from '@billy/design-system'
import { useCallback, useRef } from 'react'
import { useClickAway } from 'react-use'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useInvoiceColumnVisibilitySettingsForm } from '../../../../../../../../../../contexts/invoiceColumnVisibilityFormContext'
import { OptionalColumnsSettings } from './elements/OptionalColumnsSettings'
import { TotalPriceColumnsSettings } from './elements/TotalPriceColumnsSettings'
import * as Styled from './styles'

export const InvoiceColumnsVisibilitySettings = () => {
  const columnSettingsRef = useRef<HTMLDivElement>(null)
  const { organization } = useUserOrganization()

  const shouldShowVatRelatedSettings = !organization?.isVatExempted

  const { invoiceLinesColumnsVisibilityForm, submitForm } = useInvoiceColumnVisibilitySettingsForm()
  const { Form: InvoiceColumnVisibilityFormProvider } = invoiceLinesColumnsVisibilityForm

  const handleClickAway = useCallback(() => {
    submitForm()
  }, [submitForm])

  useClickAway(columnSettingsRef, handleClickAway)

  return (
    <Styled.InvoiceColumnsVisibilitySettingsWrapper ref={columnSettingsRef}>
      <InvoiceColumnVisibilityFormProvider>
        <Flex flexDirection="column" gap={Spacing.S12}>
          <OptionalColumnsSettings />
          {shouldShowVatRelatedSettings && (
            <>
              <Divider />
              <TotalPriceColumnsSettings />
            </>
          )}
        </Flex>
      </InvoiceColumnVisibilityFormProvider>
    </Styled.InvoiceColumnsVisibilitySettingsWrapper>
  )
}
